import React, { useState, useRef } from 'react';
import "./Event.css";
import useScrollAnimation from "../constants/useScrollAnimation";

export default function Event() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const gridRef = useRef(null);
  const [headerRef, isHeaderVisible] = useScrollAnimation(0.2);
  const [contentRef, isContentVisible] = useScrollAnimation(0.2);

  const events = [
    { title: "Asia Education Conclave 2024", img: "/images/events/Asia_Education_Conclave_2024.jpg" },
    { title: "CBSE Cluster-II Table Tennis Championship 2024", img: "/images/events/CBSE_Cluster-II_Table_Tennis_Championship_2024.jpg" },
    { title: "Educational Excursion", img: "/images/events/Educational_Excursion.jpg" },
    { title: "Exciting Excursion", img: "/images/events/Exciting_Excursion.jpg" },
    { title: "Festive Activities", img: "/images/events/Festive_Activities.jpg" },
    { title: "Honorary Academician", img: "/images/events/Honorary_Academician.jpg" },
    { title: "International Dance Day", img: "/images/events/International_Dance Day.jpg" },
    { title: "Sarodiya Celebrations", img: "/images/events/Sarodiya_Celebrations.jpg" },
    { title: "State Badminton Championship", img: "/images/events/State_Badminton_Championship.jpg" },
  ];

  const getGridPosition = (index) => {
    const col = index % 3;
    const row = Math.floor(index / 3);
    return { col, row };
  };

  const handleMouseMove = (e) => {
    if (!gridRef.current) return;

    const rect = gridRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const col = Math.floor((x / rect.width) * 3);
    const row = Math.floor((y / rect.height) * 3);

    const index = row * 3 + col;

    if (index >= 0 && index < 9) {
      setHoveredIndex(index);
    }
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };






  return (
    <>

      <section>
        <div className="">

          <div className="container-custom">
            <div ref={headerRef} className={`section-header ${isHeaderVisible ? "animate-in" : ""}`}>
              <div className="section-title-body">
                <div>
                  <h3 className="section-title-hm">Events</h3>
                </div>
                <div>
                  <a href="#" class="btn-com school-view"> Learn more</a>
                </div>
              </div>
              <p className="section-desc body-txt">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy text
                ever since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book. It has survived not
                only five centuries, but also the leap into electronic
              </p>
            </div>

            <div ref={contentRef} className={`row schools-right ${isContentVisible ? "animate-in" : ""}`}>
              <div className="col">
                <div
                  ref={gridRef}
                  className="grid-container"
                  onMouseMove={handleMouseMove}
                  onMouseLeave={handleMouseLeave}
                >
                  {/* Grid lines */}
                  <div className={`grid-lines ${hoveredIndex !== null ? "hide-grid" : ""}`}>
                    {[...Array(9)].map((_, i) => (
                      <div key={i} className="grid-line-cell" />
                    ))}
                  </div>

                  {/* Grid items */}
                  {events.map((event, index) => {
                    const { col, row } = getGridPosition(index);
                    const isHovered = hoveredIndex === index;

                    return (
                      <div
                        key={index}
                        className="grid-item"
                        style={{
                          left: isHovered ? '0%' : `${col * 33.333}%`,
                          top: isHovered ? '0%' : `${row * 33.333}%`,
                          width: isHovered ? '100%' : '33.333%',
                          height: isHovered ? '100%' : '33.333%',
                          zIndex: isHovered ? 20 : 1
                        }}
                      >
                        <div className={`grid-item-content ${event.color}`}>
                          <img
                            src={event.img}
                            alt={event.title}
                            className="grid-item-img"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        </div>
                        <div className="gradient-overlay" />
                        <div className="item-title">
                          <h3>{event.title}</h3>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}